var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.66602H12C11.2636 2.66602 10.6667 3.26297 10.6667 3.99935V6.66602C10.6667 7.4024 11.2636 7.99935 12 7.99935H20C20.7364 7.99935 21.3333 7.4024 21.3333 6.66602V3.99935C21.3333 3.26297 20.7364 2.66602 20 2.66602Z",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33398H8.00001C7.29277 5.33398 6.61449 5.61494 6.11439 6.11503C5.61429 6.61513 5.33334 7.29341 5.33334 8.00065V26.6673C5.33334 27.3746 5.61429 28.0528 6.11439 28.5529C6.61449 29.053 7.29277 29.334 8.00001 29.334H24C24.7073 29.334 25.3855 29.053 25.8856 28.5529C26.3857 28.0528 26.6667 27.3746 26.6667 26.6673V26.0007",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 5.33398H24C24.4676 5.33446 24.9269 5.45791 25.3318 5.69193C25.7366 5.92596 26.0728 6.26233 26.3067 6.66732",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 24H12",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504 16.8349C29.0351 16.3037 29.3335 15.5833 29.3335 14.8322C29.3335 14.0811 29.0351 13.3607 28.504 12.8295C27.9729 12.2984 27.2525 12 26.5013 12C25.7502 12 25.0298 12.2984 24.4987 12.8295L19.152 18.1789C18.835 18.4957 18.603 18.8873 18.4773 19.3175L17.3613 23.1442C17.3279 23.2589 17.3259 23.3805 17.3555 23.4963C17.3852 23.6121 17.4454 23.7178 17.5299 23.8023C17.6144 23.8868 17.7201 23.947 17.8359 23.9767C17.9517 24.0063 18.0733 24.0043 18.188 23.9709L22.0147 22.8549C22.4449 22.7292 22.8365 22.4972 23.1533 22.1802L28.504 16.8349Z",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryEvaluation);
export default __webpack_public_path__ + "static/media/primary-evaluation.387c0e0eb013ee5e3720593e31e3dbcb.svg";
export { ForwardRef as ReactComponent };